export default __webpack_public_path__ + "static/media/yuantain.90bdf05e.jpg";